import { FC } from 'react';
import Box from '@mui/material/Box/Box';

import {
  AILSV2Wrapper,
  FirstSectionDescription,
  FirstSectionTitle,
  FirstSectionWrapper,
  IconWrapper,
  ItemDescription,
  ItemsWrapper,
  ItemTitle,
  ItemWrapper,
  ListItem,
  SecondSectionTitle,
  SecondSectionWrapper,
} from './AILSV2.styles';

import { IInformationData } from 'types/applications';

const AILSV2: FC<IInformationData> = ({ title, description, items, listTitle, listItems }) => {
  return (
    <AILSV2Wrapper>
      <FirstSectionWrapper>
        <FirstSectionTitle>{title}</FirstSectionTitle>

        <FirstSectionDescription>{description}</FirstSectionDescription>
      </FirstSectionWrapper>

      <SecondSectionWrapper>
        <Box display="flex" flexDirection="column" width="100%">
          <SecondSectionTitle>{listTitle}</SecondSectionTitle>

          <ul
            style={{
              margin: 0,
              paddingLeft: '24px',
            }}
          >
            {listItems.map((item, index) => (
              <ListItem key={index}>{item}</ListItem>
            ))}
          </ul>
        </Box>

        <ItemsWrapper>
          {items.map((item, index) => (
            <ItemWrapper key={index}>
              <IconWrapper>
                <img src={item.imageSrc} alt={item.title} />
              </IconWrapper>

              <ItemTitle>{item.title}</ItemTitle>

              <ItemDescription>{item.description}</ItemDescription>
            </ItemWrapper>
          ))}
        </ItemsWrapper>
      </SecondSectionWrapper>
    </AILSV2Wrapper>
  );
};

export default AILSV2;
